import { FacadeSearchBoxDesktop } from './FacadeSearchBoxDesktop';

export type { TypeFacadeSearchBoxDesktopProps } from './types';
export default FacadeSearchBoxDesktop;
